import SideNav from '@components/common/sidebar';
import { unsetUserDetails } from '@store/slices/user.slice';
import { getAccessToken } from '@utils/helpers';
import { RootState } from '@utils/types';
import Cookies from 'js-cookie';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../header';

const Layout = () => {
  const token = getAccessToken();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);
  const userObjectLength = Object.keys(user).length;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const childDiv = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token === undefined || userObjectLength === 0) {
      Cookies.remove('ca_token');
      Cookies.remove('uuid_dp');
      dispatch(unsetUserDetails());
      navigate('/login');
    } else {
      setIsLoggedIn(true);
    }
  }, [token, userObjectLength, navigate, user, dispatch]);

  useEffect(() => {
    if (childDiv.current) {
      childDiv.current.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    isLoggedIn && (
      <>
        <Header />
        <div className="flex h-[calc(100vh-134px)] bg-gray-100 md:h-[calc(100vh-64px)]">
          <div className="hidden lg:block lg:h-full lg:w-1/6 lg:bg-white">
            <SideNav />
          </div>
          {/* Children */}
          <div className="w-full overflow-y-auto lg:w-5/6" ref={childDiv}>
            <Outlet />
          </div>
        </div>
      </>
    )
  );
};

export default Layout;
